import { AuthService } from '@teko/auth';
import { NotificationService } from '@teko/notification';
import {
  LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY,
  LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES,
  userSelectedConstants,
} from '../constants';
import { removeUserSelectedInfo } from '../helpers/env';
import { unregisterUNS } from '../modules/notification/helper';

const { TERMINAL, TERMINAL_ID, TERMINAL_NAME, TERMINALS, USER_LOCATION } =
  userSelectedConstants;

export const clearStorageOnSignout = (epicOmni1825?: boolean) => {
  [
    LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES,
    LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY,
    ...(!!epicOmni1825
      ? [TERMINAL, TERMINAL_ID, TERMINAL_NAME, TERMINALS, USER_LOCATION]
      : []),
  ].forEach((lsKey) => {
    const actualKey = [TERMINALS, USER_LOCATION].includes(lsKey)
      ? lsKey.toUpperCase()
      : lsKey;
    localStorage.removeItem(actualKey);
    localStorage.removeItem(`${actualKey}_mobile`);
  });
};

export const clearCookiesOnLogout = () => {
  [TERMINAL, TERMINAL_ID, TERMINAL_NAME].forEach((lsKey) => {
    removeUserSelectedInfo(lsKey);
    removeUserSelectedInfo(lsKey, true); //key on mobile view
  });
};

export const onSignOut = async (
  authService: AuthService,
  notificationService: NotificationService,
  notificationAppId: string,
  redirectUrl?: string,
  epicOmni1825?: boolean,
): Promise<void> => {
  unregisterUNS(notificationService, notificationAppId);
  authService.logout(redirectUrl);
  clearStorageOnSignout(epicOmni1825);
  if (!!epicOmni1825) {
    clearCookiesOnLogout();
  }
};
